import React ,{useState} from 'react';
import NavBar from './common/MenuBar';
import { sendEmail, insertContactUsPBMS } from '../Services/loadOrder';
import '../assets/css/home.css';
import { ChevronLeft } from 'lucide-react';
import toast, {Toaster} from 'react-hot-toast';
import logo from '../assets/images/logo-win-white.svg'
import ConfirmMailModal from './common/ConfirmMailModal';

const ContactUs =  () =>{

  const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.userId;
    const pharmacyId = user?.pharmacyId || '';
    const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fromAddress = document.getElementById('fromAddress').value;
    const toAddress = document.getElementById('toAddress').value;
    const comments = document.getElementById('comments').value;
    const senderEmail = document.getElementById('senderAddress').value;
    //console.log(fromAddress, toAddress, comments, senderEmail);

    console.log("fromAddress", fromAddress);
    console.log("toAddress", toAddress);
    console.log("comments", comments);
    console.log("senderEmail", senderEmail);
 
    if (toAddress === '--select--' || comments.trim() === '') {
      toast.error('Please fill in all fields.');
      return;
    }

    const saveData = await insertContactUsPBMS( fromAddress, senderEmail, toAddress, comments  ); 

    if (saveData?.Result === 'Success' || saveData?.Result === 'SUCCESS') {

    const response = await sendEmail(fromAddress, comments, toAddress, senderEmail,    )
      if (response) {
        toast.success('Message sent successfully!');
        setShowConfirm(true);
      } else {
        console.error('Error sending message:');
        toast.error('Failed to send message. Please try again later.');
      };
  }
}

   const handleCancel = () => {
    window.close();
  };
    return(
        <>
         <div className = 'body-style'>
        <div className="contact-page ">
            <Toaster position="top-right" />
            <header className="top-logo">
                <img src={logo} alt="Logo" />
            </header>

<div
  className="contact-us-container"
  style={{
    background: '#fff',
    padding: '35px 40px',
    borderRadius: '60px',
    width: '400px',
    margin: '40px auto',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    fontFamily: 'Segoe UI',
    textAlign: 'center'
  }}
>
  {/* <img src= {logo} alt="WIN Logo" className="contact-us-logo" /> */}

  {/* <div className="contact-us-inner-container"> */}
 {/* Title */}
  <h1 style={{ marginBottom: '5px', fontSize: '22px',color:'#ec008c', textAlign:'center', fontWeight:'normal'} }>Leave us a message</h1>
    {/* Email Input */}
  <div style={{ width: '100%' }}>
    <input
      type="text"
      id="fromAddress"
      placeholder="Enter PharmacyID"
      style={{
        padding: '10px 12px',
        width: '90%',
        borderRadius: '20px',
        border: '.5px solid #ec008c',
        fontSize: '14px',
        fontFamily: 'Segoe UI',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid #ccc';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }}
    />
  </div>
  {/* Sender Email */}

  <div style={{ width: '100%' }}>
    <input
      type="text"
      id="senderAddress"
      placeholder="Enter your email ID"
      style={{
        padding: '10px 12px',
        width: '90%',
        borderRadius: '20px',
        border: '.5px solid #ec008c',
        fontSize: '14px',
        fontFamily: 'Segoe UI',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid #ccc';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }}
    />
  </div>
    {/* Dropdown */}
  <div style={{ textAlign: 'left', width: '100%' }}>
    <label
      htmlFor="toAddress"
      style={{
        display: 'block',
        marginBottom: '6px',
        fontSize: '14px',
        fontWeight: '500',
        color: '#333'
      }}
    >
      To
    </label>
    <select
      name="toAddress"
      id="toAddress"
      style={{
        padding: '10px 12px',
        width: '99%',
        borderRadius: '20px',
        border: '.5px solid #ec008c',
        fontSize: '14px',
        fontFamily: 'Segoe UI',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        outline: 'none',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff'
        }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid #ccc';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }}
    >
      <option value="--select--">--Select--</option>
      <option value="Technical Department">Technical Department</option>
      <option value="Clinical Department">Clinical Department</option>
      <option value="Claims Department">Claims Department</option>
    </select>
  </div>
    {/* Textarea */}
  <div style={{ width: '100%' }}>
    <textarea
      id="comments"
      placeholder="Enter your comments"
      style={{
        padding: '10px 12px',
        width: '90%',
        borderRadius: '20px',
        border: '.5px solid #ec008c',
        fontSize: '14px',
        fontFamily: 'Segoe UI',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '100px',
        resize: 'none'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid #ccc';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }}
    />
  </div>
    {/* Buttons inside */}
  <div
    className="button-contact-div"
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '10px'
    }}
  >
    <button className="button-contact-mail" onClick={handleCancel}>
      Cancel
    </button>
    <button className="button-contact-mail" onClick={handleSubmit}>
      Send
    </button>
  </div>
  </div>
  
</div> 


        </div>
        {/* </div> */}
        <ConfirmMailModal open={showConfirm} />
        </>
    );
}

export default ContactUs;